export const getScrollDurationMs = () => {
  if (typeof document === "undefined") return 1000
  const raw = document.body?.getAttribute("data-scroll-time")
  const value = raw != null ? Number(raw) : 1
  return Number.isFinite(value) ? Math.max(0, value) * 1000 : 1000
}

export const prefersReducedMotion = () => {
  if (typeof window === "undefined" || !window.matchMedia) return false
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
}

let cancelActiveScroll = null

export const smoothScrollTo = (el) => {
  if (!el || typeof window === "undefined") return
  if (cancelActiveScroll) {
    cancelActiveScroll()
  }

  if (prefersReducedMotion()) {
    el.scrollIntoView({ behavior: "auto", block: "start" })
    return
  }

  const duration = getScrollDurationMs()
  if (duration === 0) {
    el.scrollIntoView({ behavior: "auto", block: "start" })
    return
  }

  const start = window.pageYOffset
  const target = el.getBoundingClientRect().top + start
  const startTime = performance.now()
  let cancelled = false

  const cleanup = () => {
    window.removeEventListener("wheel", cancelScroll)
    window.removeEventListener("touchstart", cancelScroll)
    window.removeEventListener("touchmove", cancelScroll)
    window.removeEventListener("keydown", cancelScroll)
    if (cancelActiveScroll === cancelScroll) {
      cancelActiveScroll = null
    }
  }

  const cancelScroll = () => {
    cancelled = true
    cleanup()
  }

  cancelActiveScroll = cancelScroll
  window.addEventListener("wheel", cancelScroll, { passive: true })
  window.addEventListener("touchstart", cancelScroll, { passive: true })
  window.addEventListener("touchmove", cancelScroll, { passive: true })
  window.addEventListener("keydown", cancelScroll)

  const easeInOutCubic = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2

  const step = (now) => {
    if (cancelled) return

    const elapsed = now - startTime
    const progress = Math.min(elapsed / duration, 1)
    const eased = easeInOutCubic(progress)
    window.scrollTo(0, start + (target - start) * eased)
    if (progress < 1) {
      requestAnimationFrame(step)
      return
    }

    cleanup()
  }

  requestAnimationFrame(step)
}
